import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [{
    id: 'es',
    name: i18n.t('langs.es'),
    localName: i18n.t('langs_select.es')
  },
  {
    id: 'en-GB',
    name: i18n.t('langs.en'),
    localName: i18n.t('langs_select.en')
  },
  {
    id: 'fr',
    name: i18n.t('langs.fr'),
    localName: i18n.t('langs_select.fr')
  },
  {
    id: 'de',
    name: i18n.t('langs.de'),
    localName: i18n.t('langs_select.de')
  },
  {
    id: 'ca',
    name: i18n.t('langs.ca'),
    localName: i18n.t('langs_select.ca')
  },
  {
    id: 'gl',
    name: i18n.t('langs.gl'),
    localName: i18n.t('langs_select.gl')
  },
  {
    id: 'eu',
    name: i18n.t('langs.eu'),
    localName: i18n.t('langs_select.eu')
  },
  ]
}

export function TIPOS_IDIOMA (state) {
  return configHelper.getConfig(state, 'TIPOS_IDIOMA', GenerateConfig)
}
